import script from "./HomeContactForm.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeContactForm.vue?vue&type=script&setup=true&lang=js"

import "./HomeContactForm.vue?vue&type=style&index=0&id=63d1d419&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63d1d419"]])

export default __exports__